import { useState } from "react";
// import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { loginMethod } from "../../hooks/auth";
import CustomInput from "../CustomInput/CustomInput";
import CustomBtn from "../CustomBtn/CustomBtn";
import { useDispatch, useSelector } from "react-redux"
import enLang from "../../assets/lang.svg"
import arLang from "../../assets/arlang.png"
import "./LoginForm.css";
import { FaEye, FaEyeSlash } from "react-icons/fa"; // Import icons for show/hide
import axios from "axios";
import { changeLocal } from "../../hooks/Localization";
import { getToken } from "firebase/messaging";
import { messaging } from "../../firebase-config";

function LoginForm() {
  const { currentLocal } = useSelector((state) => state.currentLocal);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false); // State to toggle visibility
  const [loading, setLoading] = useState(false);
  const [emailError, setEmailError] = useState(false)
  const [passwordError, setPasswordError] = useState(false)
  const handleLang = (lang) => {
    dispatch(
      changeLocal(lang)
    );
  }

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!email || !password) {
      toast.error("Please fill all fields", { position: "bottom-right", autoClose: 3000 });
    } else {
      // if(email=="admin@admin.com"&&password=="123456"){
      //     console.log(email&&password);

      //     navigate("/dashboard/dashboard");
      //     localStorage.setItem("type", "admin");

      // }else if(email=="admin1@admin.com"&&password=="123456"){
      //     console.log(email&&password);

      //     navigate("/dashboard/dashboard");
      //     localStorage.setItem("type", "maintenance");

      // }else if(email=="admin2@admin.com"&&password=="123456"){
      //     console.log(email&&password);

      //     navigate("/dashboard/dashboard");
      //     localStorage.setItem("type", "salaries");

      // }else if(email=="admin3@admin.com"&&password=="123456"){
      //     console.log(email&&password);

      //     navigate("/dashboard/dashboard");
      //     localStorage.setItem("type", "purchases");

      // }else if(email=="admin4@admin.com"&&password=="123456"){
      //     console.log(email&&password);

      //     navigate("/dashboard/dashboard");
      //     localStorage.setItem("type", "sales");

      // }
      // navigate("/dashboard");


      setLoading(true);
      try {
        //                 const currentToken = await getToken(messaging, { 
        //   vapidKey: "BLYW9gxwYihDwNKMlJ02JZmgPVZRDkyHTdacjcRZSCyT_g0conRX3ZfH2aSA5fTr956jdPOjW_0eqlvtptljeRU" 
        // });

        const data = email.includes("@") ?
          { email: email, password }
          :
          { identity_number: email, password }
        const response = await axios.post(
          "https://nanosoft.space/taarteb/public/api/user/auth/login",
          // { email, password,fcm_token:currentToken }
          data
        );
                  toast.success(response.data.message, { position: "bottom-right", autoClose: 3000 });

setTimeout(() => {

        dispatch(loginMethod(response.data.data));
        setLoading(false)
        
const roleText=Array.isArray(response.data.data?.user?.role)?response.data.data?.user?.role[0] :response.data.data?.user?.role
        console.log(roleText);

        if (roleText == "Purchasing Employee") {
        localStorage.setItem("type", "purchases");
          navigate("/dashboard/dashboard");
        } else if (roleText == "Maintenance Employee") {
          localStorage.setItem("type", "maintenance");
          navigate("/dashboard/dashboard");


        } else if (roleText == "Salaries Employee") {
          localStorage.setItem("type", "salaries");
          navigate("/dashboard/dashboard");

        }
        else if (roleText == "Sales Employee") {
          localStorage.setItem("type", "sales");
          navigate("/dashboard/dashboard");

        }
        else if (roleText == "Financial Director") {
          localStorage.setItem("type", "financial");
          navigate("/dashboard/dashboard");

        }
        else if (roleText == "Student") {
          if (!response?.data?.data?.user?.student?.register_fee_image) {
            localStorage.setItem("type", "student");
            navigate("/payment");

          }else {
            localStorage.setItem("type", "student");
            navigate("/dashboard/dashboard");

          }


        } else if (roleText == "School Manager") {
          localStorage.setItem("type", "admin");
          navigate("/dashboard/dashboard");

        } else if(roleText == "Teacher"){
            localStorage.setItem("type", "teacher");
            navigate("/dashboard/dashboard");

          }
}, 3500);

      } catch (error) {
        setLoading(false)
        if (Object.values(error.response.data.errors)[0][0].includes('Email')) {
          setEmailError(true)
          toast.error(currentLocal.language === "English" ? Object.values(error.response.data.errors)[0][0] : "البريد الالكتروني غير صحيح", { position: "top-right", autoClose: 3000 });

        } else {
          setPasswordError(true)
          toast.error(currentLocal.language === "English" ? "The selected password is invalid." : "كلمة المرورو غير صحيحة", { position: "top-right", autoClose: 3000 });

        }


      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <div className="login_form_container">
      <ToastContainer />
      <h1 className="title">{currentLocal.home.welcome}</h1>
      <p className="paragraph">{currentLocal.home.subtitle}</p>

      <form className=" d-flex flex-column justify-content-center align-items-center w-100" onSubmit={handleLogin}>
        <div className="form_container_cart w-75">
          <CustomInput
            placeholder={currentLocal.home.email + " " + currentLocal.home.or + " " + currentLocal.home.studentCivilId}
            value={email}
            onChange={(e) => {
              setEmailError(false)
              setEmail(e.target.value)
            }}
            inputState={emailError}

          />
        </div>
        <div className="form_container_cart position-relative w-75">
          <CustomInput
            type={showPassword ? "text" : "password"} // Toggle input type
            placeholder={currentLocal.home.passwordPlaceholder}
            value={password}
            onChange={(e) => {
              setPasswordError(false)
              setPassword(e.target.value)
            }}
            inputState={passwordError}

          />
          {/* Eye Icon to Toggle Password */}
          <span
            className="eye-icon"
            onClick={() => setShowPassword(!showPassword)}
            style={{
              position: "absolute",
              right: currentLocal.language === "English" && "10px",
              left: currentLocal.language === "العربيه" && "10px",

              top: "35%",
              transform: "translateY(-50%)",
              cursor: "pointer"
            }}
          >
            {showPassword ? <FaEyeSlash /> : <FaEye />}
          </span>
          {/* <p className="text-danger mb-4"style={{fontSize:"13px",textDecoration:"underLine",textAlign:"end",cursor:"pointer"}}onClick={()=>navigate("/forget-password")}>{currentLocal.home.forgetPassword}</p> */}
        </div>
        <div className="w-75">
          <CustomBtn text={loading ? currentLocal.home.Loading : currentLocal.home.login} disabled={loading} type={"submit"} />

        </div>
        <div className="signup_link" onClick={() => {
          navigate("/registration-conditions")
        }}>{currentLocal.home.signupasStudent}</div>
      </form>
    </div>
  );
}

export default LoginForm;
